import React, { useState, useEffect } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import {
      CardHeader,
      CardLinks,
      CardTitle
} from '../../styles/components/common/Table';
import { LinkButton } from '../../styles/components/common/Button';

import axios from 'axios';
import { toast } from 'react-hot-toast';
import Input from '../../components/Form/Input';
import FormButton from '../../components/Form/Button';
import FormImage from '../../components/Form/image';
import { useParams } from 'react-router-dom';
import FormSelect from '../../components/Form/FormSelect';

const UserEdit = () => {
      const { userId } = useParams();

      const [roles, setRoles] = useState([]);
      const [type, setType] = useState('text');
      const [loadingData, setLoadingData] = useState(false);

      const [name, setName] = useState('');
      const [email, setEmail] = useState('');
      const [password, setPassword] = useState('');
      const [confirmPassword, setConfirmPassword] = useState('');
      const [phoneNumber, setPhoneNumber] = useState('');
      const [image, setImage] = useState('');
      const [imageUrl, setImageUrl] = useState('');
      const [role, setRole] = useState('');
      const [loading, setLoading] = useState(false);

      const token = JSON.parse(localStorage.getItem('token'));

      const loadData = async () => {
            setLoadingData(true);
            await axios
                  .get(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/users/${userId}`,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setName(response.data.user.name);
                              setEmail(response.data.user.email);
                              setImageUrl(response.data.user.photo);
                              setPhoneNumber(response.data.user.phone_number);
                              setRole(response.data.user.role_id);
                              setRoles(response.data.roles);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoadingData(false);
      };

      useEffect(() => {
            loadData();
      }, []);

      const handleForm = async (event) => {
            event.preventDefault();
            setLoading(true);
            const data = {
                  name: name,
                  email: email,
                  phone_number: phoneNumber,
                  password: password,
                  password_confirmation: confirmPassword,
                  image: image,
                  role: role
            };

            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/users/${userId}`,
                        data,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`,
                                    'Content-Type': 'multipart/form-data'
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              toast.success(response.data.message);
                        }
                        if (response.data.result === 'error') {
                              if (response.data.message.name) {
                                    toast.error(response.data.message.name);
                              }
                              if (response.data.message.email) {
                                    toast.error(response.data.message.email);
                              }
                              if (response.data.message.phone_number) {
                                    toast.error(
                                          response.data.message.phone_number
                                    );
                              }
                              if (response.data.message.password) {
                                    toast.error(response.data.message.password);
                              }
                              if (response.data.message.image) {
                                    toast.error(response.data.message.image);
                              }
                              if (response.data.message.role) {
                                    toast.error(response.data.message.role);
                              }
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      const handleType = () => {
            setType('password');
      };

      return (
            <>
                  <Form onSubmit={handleForm}>
                        <Row>
                              <Col lg={12}>
                                    <Card>
                                          <CardHeader>
                                                <CardTitle>Edit User</CardTitle>
                                                <CardLinks>
                                                      <LinkButton to="/dashboard/users">
                                                            Back
                                                      </LinkButton>
                                                </CardLinks>
                                          </CardHeader>
                                          <Card.Body>
                                                <Row className="g-3">
                                                      <Input
                                                            title="Full Name"
                                                            classes={8}
                                                            required={true}
                                                            value={name}
                                                            handleChange={
                                                                  setName
                                                            }
                                                      />
                                                      <FormSelect
                                                            loading={
                                                                  loadingData
                                                            }
                                                            classes={4}
                                                            title="Role"
                                                            setData={setRole}
                                                            required={true}
                                                            selected={role}
                                                            options={roles}
                                                      />
                                                      <Input
                                                            title="Email"
                                                            required={true}
                                                            value={email}
                                                            type="email"
                                                            handleChange={
                                                                  setEmail
                                                            }
                                                      />
                                                      <Input
                                                            title="Phone Number"
                                                            value={phoneNumber}
                                                            handleChange={
                                                                  setPhoneNumber
                                                            }
                                                            type="text"
                                                      />
                                                      <Input
                                                            title="Password"
                                                            type={type}
                                                            handleChange={
                                                                  setPassword
                                                            }
                                                            onClick={handleType}
                                                            onBlur={handleType}
                                                      />
                                                      <Input
                                                            title="Confirm Password"
                                                            type={type}
                                                            handleChange={
                                                                  setConfirmPassword
                                                            }
                                                            onClick={handleType}
                                                            onBlur={handleType}
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>
                                    <Card className="mt-4">
                                          <Card.Body>
                                                <Row className="g-3">
                                                      <FormImage
                                                            title="Featured Image"
                                                            setImage={setImage}
                                                            setImageUrl={
                                                                  setImageUrl
                                                            }
                                                            required={false}
                                                            imageUrl={imageUrl}
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>
                                    <Card className="mt-4 mb-5">
                                          <Card.Body>
                                                <Row>
                                                      <Col lg={12}>
                                                            <FormButton
                                                                  title="Submit"
                                                                  loading={
                                                                        loading
                                                                  }
                                                            />
                                                      </Col>
                                                </Row>
                                          </Card.Body>
                                    </Card>
                              </Col>
                        </Row>
                  </Form>
            </>
      );
};

export default UserEdit;
